import { FC } from 'react';

import styled from '@emotion/styled';

import { LoadingCard } from '@britishcouncil/react-solas-ors3';

export const FullScreenLoadingBox: FC<{ title?: string; text?: string }> = ({
  title,
  text,
}) => (
  <StyledBox>
    <LoadingCard title={title}>{text || 'One second, please'}</LoadingCard>
  </StyledBox>
);

const StyledBox = styled.div`
  height: 100vh;
  align-items: center;
  display: flex;
  justify-content: center;
  & > div {
    width: 100%;
  }
`;
